import { RouteRecordRaw } from 'vue-router';
import { getCurrentTenant } from '@/utils/tenant';
import { parseDefaultTenantMenu } from './parsers/default';

/**
 * 统一路由转换入口
 * 根据租户类型自动选择对应的解析器，将后端菜单数据转换为Vue Router路由配置
 * 
 * @param data 后端返回的菜单数据数组
 * @returns Vue Router路由配置数组
 * 
 * @example
 * // 默认租户格式
 * const defaultMenu = [{ name: 'home', path: 'home', children: [...] }]
 * const routes = resetMenuToRouter(defaultMenu)
 * 
 * @example
 * // Luatos租户格式
 * const luatosMenu = [{ m: '首页', pid: 'home', uri: '/page/home', subs: [...] }]
 * const routes = resetMenuToRouter(luatosMenu)
 */
export function resetMenuToRouter(data: any[]): RouteRecordRaw[] {
  if (!Array.isArray(data) || data.length === 0) return [];

  // const tenant = getCurrentTenant();

  // // 根据租户 ID 选择解析器
  // if (tenant?.id === 'luatos') {
  //   console.log('[DynamicRouter] 使用 Luatos 租户解析器');
  //   return parseLuatosTenantMenu(data);
  // }

  // 默认解析器
  console.log('[DynamicRouter] 使用默认租户解析器');
  return parseDefaultTenantMenu(data);
}

/**
 * 将菜单转换为路由并添加到路由表
 * 
 * 功能说明：
 * 1. 调用 resetMenuToRouter 生成路由配置
 * 2. 将生成的路由递归添加到 Vue Router（作为 rootLayout 的子路由）
 * 3. 设置 userMenuRouter（用于底部导航栏等UI组件）
 * 
 * 数据流：
 * userStore.routerData (后端原始数据) 
 *   -> resetMenuToRouter (转换) 
 *   -> router.addRoute (注册) 
 *   -> userStore.userMenuRouter (UI数据源)
 * 
 * @param userStore 用户store实例，包含routerData和userMenuRouter
 * @param router Vue Router实例
 */
export const exChangeMenuToRouter = (userStore: any, router: any) => {
  const routes = resetMenuToRouter(userStore.routerData || []);

  if (!Array.isArray(routes) || routes.length === 0) {
    console.warn('动态路由生成失败：菜单数据为空');
    userStore.userMenuRouter = [];
    return;
  }

  // 保存到store，供UI组件使用（如底部导航栏）
  userStore.userMenuRouter = routes;

  /**
   * 递归添加路由到Vue Router
   * @param route 路由配置对象
   * @param parentName 父路由名称，默认为 'rootLayout'
   */
  const addRouteRecursive = (route: any, parentName = 'rootLayout') => {
    if (!route || !route.name) return;
    if (router.hasRoute(String(route.name))) return;

    router.addRoute(parentName, route);

    // 递归添加子路由
    if (route.children && route.children.length > 0) {
      route.children.forEach((child: any) => {
        addRouteRecursive(child, route.name);
      });
    }
  };

  routes.forEach((r: any) => {
    addRouteRecursive(r);
  });
}; 